import React, { useEffect, useState } from 'react';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import makeStyles from '@mui/styles/makeStyles';
import Container from '@mui/material/Container';
import { TextField } from '@mui/material';

import { useForm } from 'react-hook-form';
import { Modal } from '../../../components/BootstrapToMUI';
import moment from 'moment';
import request from '../../../services/Request';
import Swal from 'sweetalert2';

const useStyles = makeStyles((theme) => ({
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(3),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
}));
function isPaidPeriod(currentMonth, startMonth, paidPeriod) {
  // Calculate the current position within the payment cycle
  var monthsSinceStart = (currentMonth - startMonth + 12) % 12; // Handle negative result
  var isInPaidPeriod = monthsSinceStart % paidPeriod === 0;

  return isInPaidPeriod;
}

function getLastDateOfPreviousMonth() {
  var today = new Date();
  var year = today.getFullYear();
  var month = today.getMonth(); // current month (0-indexed)

  // Go back to the previous month
  if (month === 0) {
    // if it's January
    month = 11; // set it to December
    year--; // decrement the year
  } else {
    month--; // otherwise, just go back one month
  }

  // Get the last day of the previous month
  var lastDateOfPreviousMonth = new Date(year, month + 1, 0);

  // Format the date as yyyy-mm-dd
  var formattedDate = lastDateOfPreviousMonth.toISOString().slice(0, 10);

  return formattedDate;
}

function getFirstDayOfPreviousXMonth(x) {
  var currentDate = moment();
  currentDate.subtract(x, 'months').startOf('month');
  return currentDate.format('YYYY-MM-DD');
}

export default function MagexGeFile(props) {
  const {
    reset,
    handleSubmit,
    register,
    formState: { errors },
    control,
  } = useForm({});
  const classes = useStyles();

  const { data, isloading, setIsLoading, reflesh, setReflesh, ...rest } = props;
  const [format, setFormat] = useState([]);

  useEffect(() => {
    if (props.show) {
      reset();
      const currentMonth = new Date().getMonth() + 1;
      let newArray = [];
      data.forEach((us) => {
        if (
          us.start_period &&
          us.paid_period &&
          us.service?.length > 0 &&
          us.service[0].service?._id
        ) {
          const isP = isPaidPeriod(currentMonth, us.start_period, us.paid_period);
          if (isP) {
            // get invoice date
            const endDate = getLastDateOfPreviousMonth();

            const startDate = getFirstDayOfPreviousXMonth(us.paid_period);
            newArray.push(us);
            // console.log('startDate', startDate);
            // console.log('invoiceDate', endDate);
          }
        }
      });
      // console.log('newArray', newArray);
      setFormat(newArray);
    }
    return () => {
      reset();
      setFormat([]);
      // cleanup
    };
  }, [props.show]);

  const onSubmit = (formdata) => {
    const result = Object.entries(formdata)
      .filter(([operator, invoiceNo]) => invoiceNo.trim() !== '') // Filter out empty InvoiceNo
      .map(([operator, invoiceNo]) => ({ operator, invoiceNo }));

    // console.log('result', result);

    setIsLoading(false);
    request({
      method: 'post',
      url: `/magexuser/generateMagexSalesFiles`,
      data: {
        operators: result,
      },
    })
      .then((res) => {
        Swal.fire({
          text: 'File generation completed successfully!',
          icon: 'success',
        });
        props.onHide();
        setIsLoading(true);
      })
      .catch((err) => {
        Swal.fire({
          text: err.response?.data?.error || 'An error occurred while generating the file.',
          icon: 'error',
        });
        props.onHide();
        setIsLoading(true);
      });
  };

  return (
    <Modal className="modal-w" {...rest} centered size="lg">
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter" style={{ fontSize: '1.2rem' }}>
          Generate Monthly Invoice
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="modal-body">
        <Container component="main" maxWidth="lg">
          <CssBaseline />
          <div>
            <form className={classes.form} onSubmit={handleSubmit(onSubmit)} noValidate>
              <div style={{ display: 'flex', flexWrap: 'wrap', gap: '20px' }}>
                {format?.map((data, index) => {
                  return (
                    <div
                      key={data.operator}
                      style={{ flex: '1 1 calc(25% - 20px)', marginBottom: '20px' }} // Consistent width for all items
                    >
                      <TextField
                        variant="outlined"
                        fullWidth
                        label={`${data.operator}`}
                        name={`${data.operator}`} // Dynamic name
                        InputLabelProps={{ shrink: true }}
                        {...register(`${data.operator}`, {})} // Dynamic registration
                      />
                    </div>
                  );
                })}
              </div>
              <Button
                type="submit"
                fullWidth
                variant="contained"
                color="primary"
                className={classes.submit}
              >
                Submit
              </Button>
            </form>
          </div>
        </Container>
      </Modal.Body>
    </Modal>
  );
}
